import React, { Component } from 'react';
import { Modal, Input, Form } from 'antd';

class ModalFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOk = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = {};
        params.name = values.name;
        this.props.onOk(params);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const ItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
    };
    return (
      <Modal
        title="编辑文件"
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={this.props.onCancel}
      >
        <Form>
          <Form.Item label="文件名称" {...ItemLayout}>
            {getFieldDecorator('name', {
              rules: [{ required: true, message: '请填写文件名称' }],
            })(<Input />)}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(ModalFiles);



// WEBPACK FOOTER //
// ./src/components/task/project/pageDetailManage/ModalFileEdit.js